import * as actionTypes from "../../constants/actionTypes";
import {
  getPhone,
  getPhoneIds,
  getPhonePopularIds,
  getPhones
} from "../../api/phone";
import { OFFER_TYPES } from "../../constants/offerTypes";

const invalidatePhones = () => {
  return {
    type: actionTypes.INVALIDATE_PHONES_DATA
  };
};

const loadPhone = (clientConfig, phoneId) => {
  return {
    type: actionTypes.LOAD_PHONE_DATA,
    promise: getPhone(clientConfig, phoneId)
  };
};

const loadPhonePhoneOfferIds = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_PHONE_PHONE_OFFER_IDS_DATA,
    promise: getPhoneIds(clientConfig, OFFER_TYPES.phoneOffer, dataStatus)
  };
};

const loadPhonePhoneOfferPopularIds = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_PHONE_PHONE_OFFER_POPULAR_IDS_DATA,
    promise: getPhonePopularIds(
      clientConfig,
      OFFER_TYPES.phoneOffer,
      dataStatus
    )
  };
};

const loadPhonePropositionIds = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_PHONE_PROPOSITION_IDS_DATA,
    promise: getPhoneIds(clientConfig, OFFER_TYPES.proposition, dataStatus)
  };
};

const loadPhonePropositionPopularIds = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_PHONE_PROPOSITION_POPULAR_IDS_DATA,
    promise: getPhonePopularIds(
      clientConfig,
      OFFER_TYPES.proposition,
      dataStatus
    )
  };
};

const loadPhones = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_PHONES_DATA,
    promise: getPhones(clientConfig, dataStatus)
  };
};

export {
  invalidatePhones,
  loadPhone,
  loadPhonePhoneOfferIds,
  loadPhonePhoneOfferPopularIds,
  loadPhonePropositionIds,
  loadPhonePropositionPopularIds,
  loadPhones
};
